import React from 'react';
export function Typography() {
  return <div className="min-h-screen bg-[#F7F8FA] text-[#0B0E16] py-24 px-6 md:px-12 w-full" data-id="element-430">
      <div className="max-w-4xl mx-auto space-y-24" data-id="element-431">
        {/* Header */}
        <div data-id="element-432">
          <h1 className="font-display text-5xl font-bold tracking-[-0.02em] leading-[1.08] mb-4" data-id="element-433">
            Typography System
          </h1>
          <p className="font-sans text-xl text-[#273040] leading-[1.5]" data-id="element-434">
            Reference page for SURE AI typography scales, weights, and usage.
          </p>
        </div>

        {/* 1. Rajdhani (Display) */}
        <section className="space-y-12" data-id="element-435">
          <div className="border-b border-gray-200 pb-4" data-id="element-436">
            <h2 className="font-sans text-sm font-semibold uppercase tracking-widest text-[#273040]" data-id="element-437">
              1. Display & Headings — Rajdhani
            </h2>
            <p className="font-sans text-sm text-gray-500 mt-2" data-id="element-438">
              Used for hero display, H1–H3, KPI numerics, card/module titles.
              Feel: tight, condensed, engineered.
            </p>
          </div>

          <div className="space-y-10" data-id="element-439">
            {/* Display */}
            <div data-id="element-440">
              <div className="font-display font-bold text-[72px] leading-[1.02] tracking-[-0.02em]" data-id="element-441">
                Passenger Intelligence
              </div>
              <div className="font-mono text-xs text-gray-500 mt-3" data-id="element-442">
                Display / Rajdhani Bold (700) / 72px / Line-height 1.02 /
                Tracking -0.02em
              </div>
            </div>

            {/* H1 */}
            <div data-id="element-443">
              <div className="font-display font-semibold text-[48px] leading-[1.08] tracking-[-0.02em]" data-id="element-444">
                Turn onboard data into decisions
              </div>
              <div className="font-mono text-xs text-gray-500 mt-3" data-id="element-445">
                H1 / Rajdhani SemiBold (600) / 48px / Line-height 1.08 /
                Tracking -0.02em
              </div>
            </div>

            {/* H2 */}
            <div data-id="element-446">
              <div className="font-display font-medium text-[32px] leading-[1.15] tracking-[-0.02em]" data-id="element-447">
                Operational performance signals
              </div>
              <div className="font-mono text-xs text-gray-500 mt-3" data-id="element-448">
                H2 / Rajdhani Medium (500) / 32px / Line-height 1.15 / Tracking
                -0.02em
              </div>
            </div>

            {/* H3 */}
            <div data-id="element-449">
              <div className="font-display font-medium text-[22px] leading-[1.2] tracking-normal" data-id="element-450">
                Safety and behavioural insights
              </div>
              <div className="font-mono text-xs text-gray-500 mt-3" data-id="element-451">
                H3 / Rajdhani Medium (500) / 22px / Line-height 1.2 / Tracking 0
              </div>
            </div>

            {/* KPI Numeric Example */}
            <div className="bg-[#0B0E16] p-8 rounded-lg inline-block" data-id="element-452">
              <div className="font-display font-bold text-[64px] leading-none tracking-[-0.02em] text-transparent bg-clip-text bg-gradient-to-r from-[#00FF87] to-[#00CC6A]" data-id="element-453">
                98.4%
              </div>
              <div className="font-sans text-sm font-medium text-white mt-2" data-id="element-454">
                Network Reliability
              </div>
              <div className="font-mono text-xs text-gray-400 mt-4" data-id="element-455">
                KPI Numeric / Rajdhani Bold (700) / 64px / Brand Gradient
              </div>
            </div>
          </div>
        </section>

        {/* 2. Inter Tight (Sans) */}
        <section className="space-y-12" data-id="element-456">
          <div className="border-b border-gray-200 pb-4" data-id="element-457">
            <h2 className="font-sans text-sm font-semibold uppercase tracking-widest text-[#273040]" data-id="element-458">
              2. Body & UI — Inter Tight
            </h2>
            <p className="font-sans text-sm text-gray-500 mt-2" data-id="element-459">
              Used for everything readable — body copy, buttons, labels, nav
              links.
            </p>
          </div>

          <div className="space-y-10" data-id="element-460">
            {/* Lead */}
            <div data-id="element-461">
              <div className="font-sans font-normal text-[20px] leading-[1.5] text-[#273040] max-w-2xl" data-id="element-462">
                SURE AI converts onboard video and vehicle signals into
                structured, anonymised intelligence that enables operators to
                make measurable decisions.
              </div>
              <div className="font-mono text-xs text-gray-500 mt-3" data-id="element-463">
                Lead / Inter Tight Regular (400) / 20px / Line-height 1.5 /
                Color #273040
              </div>
            </div>

            {/* Body */}
            <div data-id="element-464">
              <div className="font-sans font-normal text-[16px] leading-[1.65] text-[#273040] max-w-2xl" data-id="element-465">
                Vendor-agnostic and designed to deploy alongside existing CCTV
                and telematics without replacing current systems. Phased rollout
                supports pilots, depot-level deployments and progressive
                network-wide coverage.
              </div>
              <div className="font-mono text-xs text-gray-500 mt-3" data-id="element-466">
                Body / Inter Tight Regular (400) / 16px / Line-height 1.65 /
                Color #273040
              </div>
            </div>

            {/* Body Small (UI) */}
            <div data-id="element-467">
              <div className="font-sans font-normal text-[14px] leading-[1.5] text-[#273040]" data-id="element-468">
                Enter your email address to request a briefing.
              </div>
              <div className="font-mono text-xs text-gray-500 mt-3" data-id="element-469">
                Body Small (UI) / Inter Tight Regular (400) / 14px / Line-height
                1.5
              </div>
            </div>

            {/* Caption */}
            <div data-id="element-470">
              <div className="font-sans font-normal text-[12px] text-gray-500" data-id="element-471">
                * Data is anonymised at the edge before transmission.
              </div>
              <div className="font-mono text-xs text-gray-500 mt-3" data-id="element-472">
                Caption / Inter Tight Regular (400) / 12px
              </div>
            </div>

            {/* Eyebrow */}
            <div data-id="element-473">
              <div className="font-sans font-semibold text-[11px] uppercase tracking-[0.22em] text-[#273040]" data-id="element-474">
                Platform Capabilities
              </div>
              <div className="font-mono text-xs text-gray-500 mt-3" data-id="element-475">
                Eyebrow / Inter Tight SemiBold (600) / 11px / Tracking 0.22em /
                Uppercase
              </div>
            </div>
          </div>
        </section>

        {/* 3. JetBrains Mono */}
        <section className="space-y-12" data-id="element-476">
          <div className="border-b border-gray-200 pb-4" data-id="element-477">
            <h2 className="font-sans text-sm font-semibold uppercase tracking-widest text-[#273040]" data-id="element-478">
              3. Tokens & Identifiers — JetBrains Mono
            </h2>
            <p className="font-sans text-sm text-gray-500 mt-2" data-id="element-479">
              Used for route IDs, vehicle IDs, metric values, timestamps, chips,
              redacted tokens.
            </p>
          </div>

          <div className="space-y-8" data-id="element-480">
            <div className="flex flex-wrap gap-4 items-center" data-id="element-481">
              <span className="font-mono text-[13px] bg-gray-200 px-2 py-1 rounded text-[#0B0E16]" data-id="element-482">
                route_47
              </span>
              <span className="font-mono text-[13px] bg-gray-200 px-2 py-1 rounded text-[#0B0E16]" data-id="element-483">
                07:42:11Z
              </span>
              <span className="font-mono text-[13px] bg-gray-200 px-2 py-1 rounded text-[#0B0E16]" data-id="element-484">
                p95 = 42s
              </span>
              <span className="font-mono text-[13px] bg-gray-200 px-2 py-1 rounded text-gray-500" data-id="element-485">
                sai_live_··········
              </span>
            </div>
            <div className="font-mono text-xs text-gray-500" data-id="element-486">
              UI Tokens / JetBrains Mono Regular (400) / 13px
            </div>

            <div className="mt-8" data-id="element-487">
              <div className="font-mono font-medium text-[24px] text-[#0B0E16]" data-id="element-488">
                80789
              </div>
              <div className="font-mono text-xs text-gray-500 mt-3" data-id="element-489">
                Mono Numeric / JetBrains Mono Medium (500) / 24px
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>;
}